import {
    IS_LOADING_LOGIN_BUTTON,
    LOGIN_USER_INFO
} from '../actions/types'

const initialState = {
    isLoading: false,
    loginUserInfo: {}
}

export default function (state = initialState, action) {
    switch (action.type) {
        case IS_LOADING_LOGIN_BUTTON: {
            return {
                ...state,
                isLoading: action.payload
            }
        }
        case LOGIN_USER_INFO: {
            return {
                ...state,
                loginUserInfo: action.payload
            }
        }
        default:
            return state
    }
}